'use client';

import { useEffect } from 'react';

/**
 * Registers the service worker once on mount, but only in production builds.
 * In dev we skip registration so iterative changes don't get masked by stale caches.
 */
export function ServiceWorkerRegister() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!('serviceWorker' in navigator)) return;
    if (process.env.NODE_ENV !== 'production') return;
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  }, []);
  return null;
}
